import { stateOptions } from "../../constants/stateList";

export type CustomerStepField = {
  name: string;
  title: string;
  placeholder?: string;
  required?: boolean;
  type?: string;
  fields?: CustomerStepField[];
  options?: { label: string; value: string }[];
  maxLength?: number;
  onlyDigits?: boolean;
};

export const licenseTypeOptions = [
  { value: "CL- 2 (Off Premise)", label: "CL- 2 (Off Premise)" },
  { value: "CL- 4", label: "CL- 4" },
  { value: "CL- 5", label: "CL- 5" },
  { value: "CL- 6 + ARVB", label: "CL- 6 + ARVB" },
  { value: "CL- 6A + ARVB", label: "CL- 6A + ARVB" },
  { value: "CL- 7 + ARVB", label: "CL- 7 + ARVB" },
  { value: "CL-9 + ARVB", label: "CL-9 + ARVB" },
  { value: "CL- 17 + ARVB", label: "CL- 17 + ARVB" },
  { value: "CL- 18 + RVB", label: "CL- 18 + RVB" },
];

export const step1Fields: CustomerStepField[] = [
  {
    name: "outletName",
    title: "Outlet Name",
    placeholder: "",
    required: true,
  },
  {
    name: "companyGST",
    title: "Company GST Number",
    placeholder: "",
    required: true,
    maxLength: 15,
  },
  {
    name: "companyPAN",
    title: "Company PAN Number",
    placeholder: "",
    required: true,
    maxLength: 10,
  },
  {
    name: "state",
    title: "State*",
    placeholder: "Select State",
    type: "dropdown",
    options: stateOptions,
    required: true,
  },
  {
    name: "pincode",
    title: "Pincode",
    placeholder: "",
    required: true,
    maxLength: 6,
    onlyDigits: true,
  },
  {
    name: "emailID",
    title: "Email ID",
    placeholder: "",
    required: true,
  },
  {
    name: "gstStateCode",
    title: "GST State Code",
    placeholder: "",
    required: false,
  },
  {
    name: "authorizedSignatory",
    title: "Company Authorized Signatory (Name)",
    placeholder: "",
    required: false,
  },
  {
    name: "vatNumber",
    title: "VAT Number (if applicable)",
    placeholder: "",
    required: false,
    maxLength: 15,
  },
  {
    name: "phoneNumber",
    title: "Phone Number",
    placeholder: "",
    maxLength: 10,
    onlyDigits: true,
  },
  {
    name: "registeredAddress",
    title: "Registered Address (as per GST)",
    placeholder: "",
    required: true,
    type: "textarea",
  },
  {
    title: "Company GST Certificate",
    name: "comp_gst_cert",
    required: true,
    type: "file",
  },
  {
    title: "Company PAN Card",
    name: "comp_pan_card",
    required: true,
    type: "file",
  },
  {
    title: "VAT Certificate (if applicable)",
    name: "comp_vat_cert",
    type: "file",
  },
];

export const step2Fields: CustomerStepField[] = [
  {
    name: "licenseName",
    title: "License Name",
    placeholder: "",
    required: true,
  },
  {
    name: "licenseType",
    title: "License Type*",
    type: "dropdown",
    placeholder: "Select License Type",
    options: licenseTypeOptions,
    required: true,
  },
  {
    name: "customerExciseRegistrationNumber",
    title: "Customer Excise Registration Number",
    placeholder: "",
    required: true,
  },
  {
    name: "licensePAN",
    title: "License PAN Number",
    placeholder: "",
    required: true,
    maxLength: 10,
  },
  {
    name: "licenseGST",
    title: "License GST Number",
    placeholder: "",
    maxLength: 15,
  },
  {
    name: "gstStateCode",
    title: "GST State Code",
    placeholder: "",
    required: false,
  },
  {
    name: "licenseAddress",
    title: "Registered Address (as per License)",
    placeholder: "",
    required: false,
    type: "textarea",
  },
  {
    title: "RVB License Copy (Signed and Sealed by Excise Range Officer)",
    name: "lic_rvb_license",
    required: true,
    type: "file",
  },
  {
    title: "License PAN Card",
    name: "lic_license_pan",
    required: true,
    type: "file",
  },
  {
    title: "License GST Certificate",
    name: "lic_gst_cert",
    required: false,
    type: "file",
  },
];

export const step3Fields: CustomerStepField[] = [
  {
    name: "bankName",
    title: "Bank Name",
    placeholder: "",
  },
  {
    name: "bankBranch",
    title: "Bank Branch",
    placeholder: "",
  },
  {
    name: "accountType",
    title: "Account Type",
    placeholder: "Select Account Type",
    type: "dropdown",
    options: [
      { value: "Current Account", label: "Current Account" },
      { value: "Savings Account", label: "Savings Account" },
    ],
  },
  {
    name: "accountNumber",
    title: "Account Number",
    placeholder: "",
    maxLength: 18,
    onlyDigits: true,
  },
  {
    name: "ifscCode",
    title: "IFSC Code",
    placeholder: "",
    maxLength: 11,
  },
  {
    name: "beneficiaryName",
    title: "Beneficiary Name",
    placeholder: "",
  },
  {
    name: "accountsDepartmentPOCName",
    title: "Accounts Department POC: Name",
    placeholder: "",
  },
  {
    name: "accountsDepartmentPOCNumber",
    title: "Accounts Department POC: Number",
    placeholder: "",
    maxLength: 12,
    onlyDigits: true,
  },
  {
    title: "Cancelled Cheque Copy",
    name: "bank_cancelled_cheque",
    type: "file",
  },
];
